import { api } from './api';

export type UserRole = 'admin' | 'tester';

export interface AllowlistUser {
  email: string;
  name: string;
  role: UserRole;
  active: boolean;
  createdAt: string;
  addedBy: string;
  superadmin?: boolean;
}

export const usersApi = {
  list: () => api.get<AllowlistUser[]>('/api/users'),
  upsert: (input: { email: string; name?: string; role?: UserRole; active?: boolean }) =>
    api.post<AllowlistUser>('/api/users', input),
  remove: (email: string) =>
    api.delete<{ deleted: boolean }>(`/api/users/${encodeURIComponent(email)}`),
};
